import { createApi, fetchBaseQuery,  } from "@reduxjs/toolkit/query/react";
import { secureBaseQuery } from "./secureBaseQuery";
import {dynamicBaseQuery} from "./dynamicBaseQuery.js";
import { api } from "../../Appjs/api.js";

export const resellerApi = createApi({
  reducerPath: "resellerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
    //  baseQuery: dynamicBaseQuery,
  tagTypes: ["Reseller", "CountryRates"],
  endpoints: (builder) => ({
    getResellerIntro: builder.query({
      query: (customer_id) => `/reseller/get-reseller-intro-by/${customer_id}`,
      providesTags: ["Reseller"],
    }),
    checkResellerStatus: builder.query({
      query: (customer_id) => `/reseller/check-reseller-exist/${customer_id}`,
      providesTags: ["Reseller"],
    }),
    getCustomerCountryData: builder.query({
      query: (customer_id) =>
        `/reseller/get-customer-country-data/${customer_id}`,
      providesTags: ["CountryRates"],
    }),
    createCustomerCountryRates: builder.mutation({
      query: (body) => ({
        url: "/reseller/create-customer-country-rates",
        method: "POST",
        body,
      }),
      invalidatesTags: ["CountryRates"],
    }),
    updateResellerIntro: builder.mutation({
      query: (body) => ({
        url: "/reseller/update-reseller-intro-by",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Reseller"],
    }),
    updateCountryRates: builder.mutation({
      query: ({ customer_country_id, ...body }) => ({
        url: `/reseller/update-country-rates/${customer_country_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["CountryRates"],
    }),
    updateCustomerBalance: builder.mutation({
      query: (body) => ({
        url: "/reseller/update-customer-balance",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Reseller"],
    }),
    getCreditHistory: builder.query({
      query: ({ fromDate, toDate, page = 1, limit = 20 }) => ({
        url: "/reseller/get-credit-history",
        method: "GET",
        params: { fromDate, toDate, page, limit },
      }),
    }),
    getCustomerService: builder.query({
      query: () => ({
        url: "/reseller/get-customer-service",
        method: "GET",
      }),
    }),

    getResellerCustomerSettings: builder.query({
      query: (customer_id) => ({
        url: `/reseller/get-reseller-customer-settings/${customer_id}`,
        method: "GET",
      }),
    }),
    updateResellerCustomerSettings: builder.mutation({
      query: ({ customer_id, ...body }) => ({
        url: `/reseller/update-reseller-customer-settings/${customer_id}`,
        method: "PATCH",
        body,
      }),
    }),
  }),
});

export const {
  useGetResellerIntroQuery,
  useCheckResellerStatusQuery,
  useGetCustomerCountryDataQuery,
  useCreateCustomerCountryRatesMutation,
  useUpdateResellerIntroMutation,
  useUpdateCountryRatesMutation,
  useUpdateCustomerBalanceMutation,
  useGetCreditHistoryQuery,
  useGetCustomerServiceQuery,
  useGetResellerCustomerSettingsQuery,
  useUpdateResellerCustomerSettingsMutation,
} = resellerApi;
